<script>import { tooltipAction, smoothScroll } from "../../../actions";
import { v4 as uuidv4 } from "uuid";
export let props = {};
$: type = props.type || "button";
$: props.disabled = props.disabled || props.fetching;
</script>

{#if props.href}
	{#if props.disabled}
		<a
			id={props.id}
			class:link={!!props.href}
			class:disabled={props.disabled}
			class={props.classNames}
			use:tooltipAction={props.tooltip}
			bind:this={props.ref}
			on:click
			aria-label={props.ariaLabel ?? 'Link'}
		>
			<slot />
		</a>
	{:else}
		<a
			id={props.id}
			href={props.href}
			class:link={!!props.href}
			class={props.classNames}
			target={props.hrefTarget ? `_${props.hrefTarget}` : ''}
			use:tooltipAction={props.tooltip}
			use:smoothScroll={props.href}
			bind:this={props.ref}
			on:click
			aria-label={props.ariaLabel ?? 'Link'}
		>
			<slot />
		</a>
	{/if}
{:else}
	<button
		{...$$restProps}
		id={props.id ?? uuidv4()}
		aria-label={props.ariaLabel ?? 'Button'}
		{type}
		disabled={props.disabled}
		class:fetching={props.fetching}
		class:btn={!!type}
		class={props.classNames}
		on:click
		on:mousedown
		on:mouseup
		on:mouseleave
		use:tooltipAction={props.tooltip}
		bind:this={props.ref}
	>
		<slot />
	</button>
{/if}

<style>.btn,.link{position:relative;transition-duration:.15s;transition-property:color,background-color,border-color,text-decoration-color,fill,stroke;transition-timing-function:cubic-bezier(.4,0,.2,1)}.btn:disabled,.link:disabled{cursor:not-allowed;opacity:.5}</style>
